import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/shared/components/Button';
import { IntakeFormTestID } from '../models/intakeForm';

interface Props {
    backText?: string;
    forwardText?: string;
    skipText?: string | null;
    disableForward?: boolean;
    onBackClick: () => void;
    onForwardClick: () => void;
    onSkipClick: () => void;
}

const ButtonsRow = styled.div({
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
});

const ButtonsContainer = styled.div({
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
});

export const CommonStepButtons: React.FC<Props> = ({
    backText,
    forwardText,
    skipText,
    disableForward = false,
    onBackClick,
    onForwardClick,
    onSkipClick,
}) => {
    const { t } = useTranslation();

    return (
        <ButtonsContainer data-testid={IntakeFormTestID.StepButtons}>
            <ButtonsRow>
                <Button fullWidth type="white" onClick={onBackClick}>
                    {backText || t('intakeForms:step_buttons.back')}
                </Button>
                <Button
                    testID={IntakeFormTestID.ForwardButton}
                    disabled={disableForward}
                    fullWidth
                    onClick={onForwardClick}
                >
                    {forwardText || t('intakeForms:step_buttons.forward')}
                </Button>
            </ButtonsRow>
            {skipText !== null && (
                <ButtonsRow>
                    <Button
                        fullWidth
                        type="noBackground"
                        onClick={onSkipClick}
                        testID={IntakeFormTestID.SkipButton}
                    >
                        {skipText || t('intakeForms:step_buttons.skip')}
                    </Button>
                </ButtonsRow>
            )}
        </ButtonsContainer>
    );
};
